module.exports = __webpack_public_path__ + "img/刘超贤讲师.71f020fb.png";